import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from '../authConfig';

/**
 * Singleton MSAL instance shared across the app and service layer.
 * Services (non-React code) import this directly to acquire tokens.
 */
export const msalInstance = new PublicClientApplication(msalConfig);
